import { render, staticRenderFns } from "./payment-received.vue?vue&type=template&id=66428c68"
import script from "./payment-received.vue?vue&type=script&lang=js"
export * from "./payment-received.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports